interface SparklineProps {
  data: number[];
  height?: number;
  color?: string;
}
export default function Sparkline({ data, height = 36, color = "#FFD166" }: SparklineProps) {
  if (!data || data.length === 0) return <div style={{ height }} />;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const points = data
    .map((v, i) => {
      const x = (i / (data.length - 1)) * 100;
      const y = max === min ? 50 : 100 - ((v - min) / (max - min)) * 100;
      return `${x},${y}`;
    })
    .join(" ");
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{ width: "100%", height }}>
      <polyline
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        points={points}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
